import { render, staticRenderFns } from "./modalWrapper.vue?vue&type=template&id=045909cd&scoped=true&lang=html&"
import script from "./modalWrapper.vue?vue&type=script&lang=js&"
export * from "./modalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./modalWrapper.vue?vue&type=style&index=0&id=045909cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045909cd",
  null
  
)

export default component.exports